import { notifySuccess, notifyError } from "@js/components/notify";

document.addEventListener("DOMContentLoaded", () => {
  // Reset Modal
  window.resetLeadsourceModal = () => {
    const form = document.getElementById("leadsourceForm");
    if (form) {
      form.reset();
      document.getElementById("leadsourceId").value = "";
    }
  };
});
